import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Example Shoelace components. Mix 'n' match however you like!
import "@shoelace-style/shoelace/dist/components/button/button.js"
import "@shoelace-style/shoelace/dist/components/icon/icon.js"
import "@shoelace-style/shoelace/dist/components/spinner/spinner.js"
import "@shoelace-style/shoelace/dist/components/icon-button/icon-button.js"; // Added for hamburger menu
import "@shoelace-style/shoelace/dist/components/drawer/drawer.js"; // Added for mobile menu drawer
import "@shoelace-style/shoelace/dist/components/input/input.js"; // Added for contact form
import "@shoelace-style/shoelace/dist/components/textarea/textarea.js"; // Added for contact form
import "@shoelace-style/shoelace/dist/components/details/details.js"; // Added for product pages
import "@shoelace-style/shoelace/dist/components/alert/alert.js"; // Added for form feedback

// Use the public icons folder:
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js"
setBasePath("/shoelace-assets")

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")

document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuTrigger = document.querySelector('.mobile-menu-trigger');
  const mobileMenuDrawer = document.querySelector('.mobile-menu-drawer');

  if (mobileMenuTrigger && mobileMenuDrawer) {
    mobileMenuTrigger.addEventListener('click', () => {
      mobileMenuDrawer.open = !mobileMenuDrawer.open;
    });
  }

  // Product page accordion functionality
  const detailsGroup = document.getElementById('product-details-group');
  if (detailsGroup) {
    const detailsElements = detailsGroup.querySelectorAll('sl-details');
    
    detailsElements.forEach(details => {
      details.addEventListener('sl-show', (event) => {
        // Close all other details elements
        detailsElements.forEach(otherDetails => {
          if (otherDetails !== event.target && otherDetails.open) {
            otherDetails.open = false;
          }
        });
      });
    });
  }

  // Logo animation management
  const logoObjects = document.querySelectorAll('.mobile-logo');
  
  logoObjects.forEach(logoObject => {
    // Check if animation has already played this session
    if (sessionStorage.getItem('logoAnimationPlayed') === 'true') {
      // Skip animation - show final state immediately
      logoObject.addEventListener('load', () => {
        const svgDoc = logoObject.contentDocument;
        if (svgDoc) {
          const svg = svgDoc.querySelector('svg');
          if (svg) {
            svg.classList.add('animation-played');
          }
        }
      });
    } else {
      // Play animation and mark as played
      logoObject.addEventListener('load', () => {
        const svgDoc = logoObject.contentDocument;
        if (svgDoc) {
          // Set flag after animation completes (4.5s total)
          setTimeout(() => {
            sessionStorage.setItem('logoAnimationPlayed', 'true');
          }, 4500);
        }
      });
    }
  });

  // Contact form handling
  const contactForm = document.getElementById('contactUsForm');
  if (contactForm) {
    contactForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      
      const formData = new FormData(contactForm);
      const submitButton = contactForm.querySelector('sl-button[type="submit"]');
      const alertContainer = document.getElementById('form-alerts');
      
      // Simple spam check - if honeypot field is filled, reject
      if (formData.get('website')) {
        console.log('Spam detected via honeypot');
        return; // Silently reject spam
      }
      
      // Clear previous alerts
      if (alertContainer) {
        alertContainer.innerHTML = '';
      }
      
      // Show loading state
      submitButton.loading = true;
      submitButton.disabled = true;
      
      try {
        const response = await fetch('/api/contact-us', {
          method: 'POST',
          body: formData
        });
        
        const result = await response.json();
        
        // Create alert element
        const alert = document.createElement('sl-alert');
        alert.variant = result.success ? 'success' : 'danger';
        alert.closable = true;
        alert.innerHTML = `
          <sl-icon slot="icon" name="${result.success ? 'check-circle' : 'exclamation-triangle'}"></sl-icon>
          ${result.message}
        `;
        
        if (alertContainer) {
          alertContainer.appendChild(alert);
          alert.show();
          
          // Scroll to alert
          alertContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        
        // Reset form on success
        if (result.success) {
          contactForm.reset();
        }
        
      } catch (error) {
        console.error('Form submission error:', error);
        
        const alert = document.createElement('sl-alert');
        alert.variant = 'danger';
        alert.closable = true;
        alert.innerHTML = `
          <sl-icon slot="icon" name="exclamation-triangle"></sl-icon>
          Sorry, there was an error sending your message. Please try again later.
        `;
        
        if (alertContainer) {
          alertContainer.appendChild(alert);
          alert.show();
        }
      } finally {
        // Reset button state
        submitButton.loading = false;
        submitButton.disabled = false;
      }
    });
  }
});
